import { HttpService } from 'core/modules/network-service';
import { get } from 'lodash';

// local dependencies
import { SERVICE_RESPONSE_STATUS, HTTP_RESPONSE_STATUS } from 'constants/common';

/*************************************************************/

/**
 * @type {class}
 * @desc DrugPricingPharmacyLocator defines an HTTP service interface to send HTTP network requets.
 * @example
 * import { DrugPricingPharmacyLocatorService } from 'services/drugPricingPharmacyLocator';
 *
 * // create service instance and send/cancel request
 * const drugPricingPharmacyLocatorService = new DrugPricingPharmacyLocatorService();
 * const result = await drugPricingPharmacyLocatorService.fetchData( '<user-id>' ); // fetch data
 * drugPricingPharmacyLocatorService.cancel(); // cancel an active request
 */
export class DrugPricingPharmacyLocatorService extends HttpService {

    // make request and fetch component data
    async fetchComponentData( { url = {}, data = {} } = {} ) {
        try {
            const response = await this.post( {
                host: CONFIG.host,
                path: url,
                data,
            } );
    
            return {
                status: get( response, 'body.status', SERVICE_RESPONSE_STATUS.FAILURE ),
                data: {
                    filters: get( response, 'body.component.data.state.filters', {} ),
                    mailOrderPharmacy: get( response, 'body.component.data.state.mailOrderPharmacy', {} ),
                    retailPharmacies: get( response, 'body.component.data.state.retailPharmacies', [] ),
                    options: get( response, 'body.component.data.options', {} ),
                    widgetTitle: get( response, 'body.component.structure.widgetConfig.title', {} ),
                    filtersConfig: get( response, 'body.component.structure.filtersConfig', {} ),
                    locationsConfig: get( response, 'body.component.structure.locationsConfig', {} )
                },
            };
        } catch( error ) {
            return {
                status: SERVICE_RESPONSE_STATUS.FAILURE,
                data: null,
            };
        }
    }

    // fetch new pharmacies when filters data changes
    async fetchPharmacies( { url = {}, data = {} } = {} ) {
        try {
            const response = await this.post( {
                host: CONFIG.host,
                path: url,
                data,
            } );
    
            return {
                status: get( response, 'body.status', SERVICE_RESPONSE_STATUS.FAILURE ),
                data: {
                    retailPharmacies: get( response, 'body.component.data.state.retailPharmacies', [] ),
                },
            };
        } catch( error ) {
            if( HTTP_RESPONSE_STATUS.NONE === get( error, 'data.status', 0 ) ) {
                return {
                    status: SERVICE_RESPONSE_STATUS.CANCELLED,
                    data: null,
                };
            } else {
                return {
                    status: SERVICE_RESPONSE_STATUS.FAILURE,
                    data: null,
                };
            }
        }
    }

    async fetchDrugPrice( { url = {}, data = {} } = {} ) {
        try {
            const response = await this.post( {
                host: CONFIG.host,
                path: url,
                data,
            } );
    
            return {
                status: get( response, 'body.status', SERVICE_RESPONSE_STATUS.FAILURE ),
                data: get( response, 'body.component.data.state', {} ),
                
            };
        } catch( error ) {
            if( HTTP_RESPONSE_STATUS.NONE === get( error, 'data.status', 0 ) ) {
                return {
                    status: SERVICE_RESPONSE_STATUS.CANCELLED,
                    data: null,
                };
            } else {
                return {
                    status: SERVICE_RESPONSE_STATUS.FAILURE,
                    data: null,
                };
            }
        }
    }
}
